"use client";
import { jsx as a, jsxs as x } from "react/jsx-runtime";
import { ChevronLeft as f, ChevronRight as p } from "@videoblocks/react-icons";
import { cn as c } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as g } from "../../../utils/styles.mjs";
const N = (n, t) => Array.from({ length: t - n }, (s, e) => e + n), b = (n, t, s = 5) => {
  const e = Math.max(1, Math.min(n - Math.floor((s - 3) / 2), t - s + 2)), r = Math.min(t, Math.max(n + Math.floor((s - 2) / 2), s - 1));
  return [
    ...e > 2 ? [1, "…"] : e > 1 ? [1] : [],
    ...N(e, r + 1),
    ...r < t - 1 ? ["…", t] : r < t ? [t] : []
  ];
}, o = "text-sm font-semibold leading-5", i = c(o, "cursor-pointer", g()), M = c(
  o,
  "flex items-center justify-center rounded-capsule px-[7px] bg-neutral-dark-1000 text-neutral-dark-100 pointer-events-none"
), w = ({
  resultsPerPage: n,
  totalResults: t,
  maxPage: s,
  currentPage: e,
  goTo: r,
  className: d
}) => {
  const m = s ?? Math.max(1, Math.ceil((t ?? 0) / n)), h = b(e, m);
  return /* @__PURE__ */ a("div", { className: "flex justify-center w-full", children: /* @__PURE__ */ x(
    "div",
    {
      className: c(
        "flex items-center justify-center gap-6 px-6 py-4 min-w-[352px] rounded-md bg-neutral-dark-200 text-neutral-dark-1000",
        d
      ),
      children: [
        e !== 1 && /* @__PURE__ */ a("button", { "aria-label": "Previous page", onClick: () => r(e - 1), className: i, children: /* @__PURE__ */ a(f, { className: "w-4 h-4 fill-current" }) }),
        h.map(
          (l, u) => l === "…" ? /* @__PURE__ */ a("span", { className: o, "aria-hidden": "true", children: "…" }, `ellipsis-${u}`) : l === e ? /* @__PURE__ */ a("button", { disabled: !0, "aria-current": "page", className: M, children: l }, l) : /* @__PURE__ */ a("button", { onClick: () => r(l), className: i, children: l }, l)
        ),
        e !== m && /* @__PURE__ */ a("button", { "aria-label": "Next page", onClick: () => r(e + 1), className: i, children: /* @__PURE__ */ a(p, { className: "w-4 h-4 fill-current" }) })
      ]
    }
  ) });
};
export {
  w as Pagination
};
